import { render, staticRenderFns } from "./BasicAndIntermediateTypingItem.vue?vue&type=template&id=6a6b54db&scoped=true&"
import script from "./BasicAndIntermediateTypingItem.vue?vue&type=script&lang=js&"
export * from "./BasicAndIntermediateTypingItem.vue?vue&type=script&lang=js&"
import style0 from "./BasicAndIntermediateTypingItem.vue?vue&type=style&index=0&id=6a6b54db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6b54db",
  null
  
)

export default component.exports